import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/icons/facebook.webp'
import _imports_1 from '@/assets/images/icons/youtube.webp'
import _imports_2 from '@/assets/images/icons/instagram.webp'


const _withScopeId = n => (_pushScopeId("data-v-fd33fd30"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "social_media_sec overlay_bg",
  id: "sswContactUs"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"container\" data-v-fd33fd30><h2 class=\"title text-center white border_none\" data-v-fd33fd30> FOLLOW US ON SOCIAL MEDIA </h2><ul class=\"socail_list\" data-v-fd33fd30><li data-v-fd33fd30><a href=\"hhttps://www.facebook.com/sswperformancewheels\" target=\"_blank\" data-v-fd33fd30><img src=\"" + _imports_0 + "\" alt=\"Facebook\" data-v-fd33fd30></a></li><li data-v-fd33fd30><a href=\"https://www.youtube.com/@SSWSA-kq5sk/about\" target=\"_blank\" data-v-fd33fd30><img src=\"" + _imports_1 + "\" alt=\"Youtube\" data-v-fd33fd30></a></li><li data-v-fd33fd30><a href=\"https://www.instagram.com/ssw.stamfordsportwheelssa\" target=\"_blank\" data-v-fd33fd30><img src=\"" + _imports_2 + "\" alt=\"Instagram\" data-v-fd33fd30></a></li></ul></div>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, _hoisted_3))
}